import { FetchListFilterOptions, FetchListOptions } from '~/api/_types';
import { AppTablePagination } from '~/components/base/tables/_types';
import { fetchCertificates } from '~/services/certificates';

export const useCertificates = (
    initialPagination?: AppTablePagination | null,
    implicitFilter?: FetchListFilterOptions[] | null
) => {
    const { data, pagination, userFilter, isLoading, request } = useApiCollectionData(
        async (opt?: FetchListOptions) => await fetchCertificates(opt),
        initialPagination,
        implicitFilter
    );

    return {
        data,
        pagination,
        userFilter,
        isLoading,
        request,
    };
};
